import { render, staticRenderFns } from "./DataBuildForFishCatch.vue?vue&type=template&id=562ca430&scoped=true&"
import script from "./DataBuildForFishCatch.vue?vue&type=script&lang=js&"
export * from "./DataBuildForFishCatch.vue?vue&type=script&lang=js&"
import style0 from "./DataBuildForFishCatch.vue?vue&type=style&index=0&id=562ca430&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562ca430",
  null
  
)

export default component.exports